
export type BookingRow = {
  readonly agentUserId: string | null;
  readonly startsAt: string | null;
  readonly endsAt: string | null;
} | null;

export interface ViewerNextBooking {
  readonly startsAt: string;
  readonly endsAt: string;
}

export function viewerNextBooking(
  bookings: ReadonlyArray<BookingRow>,
  viewerId: string | null,
  now: Date | number,
): ViewerNextBooking | null {
  if (viewerId === null) return null;
  const nowMs = typeof now === 'number' ? now : now.getTime();

  let best: ViewerNextBooking | null = null;
  let bestMs = Infinity;

  for (const b of bookings) {
    if (!b || b.agentUserId !== viewerId || !b.startsAt || !b.endsAt) continue;
    const startMs = Date.parse(b.startsAt);
    if (Number.isNaN(startMs) || startMs < nowMs) continue;
    if (startMs < bestMs) {
      bestMs = startMs;
      best = { startsAt: b.startsAt, endsAt: b.endsAt };
    }
  }

  return best;
}
